import { defineComponent as _defineComponent } from 'vue'
import Handsontable from 'handsontable';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import ModalPageSettingsContainer from '@/datura/history/containers/ModalPageSettingsContainer.vue';
import TableHistoryContainer from '@/datura/history/containers/TableHistoryContainer.vue';
import historyColumns from '@/datura/history/handsontable/columns';
import TheContentbar from '@/layout/components/TheContentbar.vue';
import ThePageSkeleton from '@/layout/components/ThePageSkeleton.vue';
import DropdownPageOptions from '@/shared/components/DropdownPageOptions.vue';
import SearchBar from '@/shared/components/SearchBar.vue';
import Button from '@/shared/components/buttons/Button.vue';
import { availableFeatures } from '@/shared/storeDynamicFeatures';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHistory',
  setup(__props) {

const router = useRouter();
const store = useStore();
const searchTerm = ref('');

const hot = ref<Handsontable | null>(null);
const modalPageSettings = ref<InstanceType<typeof ModalPageSettingsContainer>>(null);

const pageFeatureEnabled = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureEnabled(availableFeatures.FEATURE_DATURA_CONTROL),
);
const pageFeatureVisible = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_DATURA_CONTROL),
);

function onShowSettings(): void {
  modalPageSettings.value?.show();
}

return { __sfc: true,router, store, searchTerm, hot, modalPageSettings, pageFeatureEnabled, pageFeatureVisible, onShowSettings, ModalPageSettingsContainer, TableHistoryContainer, historyColumns, TheContentbar, ThePageSkeleton, DropdownPageOptions, SearchBar, Button }
}

})